module.exports = __webpack_public_path__ + "static/media/metrics-toolkit.f13d225c.png";